import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * Deletes the template for the report you want.
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const removeTemplate = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
  };

  fetch(endpoint('/delete-report-template'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default removeTemplate;
